/* src/app/admin-dashboard/company-sites/detail-site-layout/detail-site-layout.component.css */
/*# sourceMappingURL=detail-site-layout.component.css.map */
